import { FC } from 'react';

import Row from './styles';

const CalendarRow: FC = ({ children }) => <Row>{children}</Row>;

export default CalendarRow;
